/**
 * Http Client Mode enumeration
 */
export enum CoreHttpClientMode
{
    NATIVE,
    BROWSER
}